import { Link } from "react-router-dom";

export function Logo({ className = "", size = "text-2xl" }) {
  return (
    <Link to="/" data-testid="logo" className={`font-heading font-extrabold tracking-tight ${size} ${className}`}>
      <span className="text-slate-900">menu</span><span className="text-[#5aa469]">one</span>
      <span className="ml-1 rounded-md bg-[#5aa469]/10 px-1.5 py-0.5 text-[0.55em] font-bold text-[#4a8a56] align-middle">360</span>
    </Link>
  );
}
